var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"fill-height instructions"},[_c('v-col',{staticClass:"sdo-card fill-column instructions__container",attrs:{"cols":"12"}},[_c('list-view-module',{staticClass:"py-5",attrs:{"select-first":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }